
<template>
	<i>
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none'><path d='M12 17.27L17.17 20.39C17.55 20.62 18.02 20.28 17.92 19.85L16.55 13.97L21.11 10.02C21.44 9.72997 21.27 9.17997 20.82 9.13997L14.81 8.62997L12.46 3.08997C12.29 2.67997 11.71 2.67997 11.54 3.08997L9.18999 8.62997L3.17999 9.13997C2.73999 9.17997 2.55999 9.72997 2.89999 10.02L7.45999 13.97L6.08999 19.85C5.99 20.28 6.45999 20.62 6.83999 20.39L12 17.27Z' fill='#323232'/></svg>
	</i>
</template>

<script>
export default {
	name: `b-new-b-icon-grade`,
	components: {},
	computed: {},
	props: {
		spin: {
			type: Boolean,
			default: false
		}
	},
	mounted() {
		if(this.spin){
			this.$nextTick(() => this.$el.classList.add('spin'));
		}
	}
};
</script>

<style scoped lang="scss">
i {
	display: inline-block;
	vertical-align: middle;

	svg {
		width: 1em;
		height: auto;
		display: block;
	}

	*:not([fill='none']) {
		fill: currentColor;
	}
}

path.a {
	fill: none;
}

.spin {
	animation: rotation 2s infinite linear;
}

@keyframes rotation {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(359deg);
	}
}
</style>

<docs>
    IconGrade

    ```js
    <b-new-b-icon-grade />
    ```
</docs>


